module.exports = __webpack_public_path__ + "img/about-辅导项目-执业医师类.c9edce87.jpg";